export default __webpack_public_path__ + "static/footprints-2183108be99f0b13c60bf78956badbe0.jpg";